import * as api from "../api/adapters/json_api";

const type = "api_resources/vessels";

export default {
  // The vessels whose name opens a DAX brief on hover, as `[{ id, imo }]`:
  // the ones DAX shares with Finvisor, among those the user may see.
  daxBriefed: () => api.read({ type, action: "dax_briefed" }, {}),

  // Where the ship is and what it is doing there, as DAX knows it now: the leg
  // progress, the port call with its agents and planned activities.
  daxBrief: (id) => api.read({ type, id, action: "dax_brief" }, {}),
};
